import script from "./optimizeSignalAsideTipsModalElectronicTip.vue?vue&type=script&setup=true&lang=ts"
export * from "./optimizeSignalAsideTipsModalElectronicTip.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__